import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { GradebookV10Service } from '../../gradebook-V10.service';
import { ClassroomSummary } from '../../../../classroom-summary/models/classroom-summary.model';

@Component({
    selector: 'app-init-gradebook-preferences',
    templateUrl: './init-gradebook-preferences.component.html'
})
export class InitGradebookPreferencesComponent {

    course: ClassroomSummary;

    constructor(
        private dialog: MatDialogRef<InitGradebookPreferencesComponent>,
        private gradebookService: GradebookV10Service
    ) { }

    nextClick() {
        this.gradebookService.createPreferenceRecords(this.course.Id).subscribe(() => {
            this.dialog.close();
        });
    }

}
